// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"c19624f2","194":"b2bb6495","708":"8367dcb3","710":"1c1fd1a9"}[chunkId] + ".chunk.js";
};